"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Dialog2 = _interopRequireDefault(require("@mui/material/Dialog"));
var _DialogActions2 = _interopRequireDefault(require("@mui/material/DialogActions"));
var _DialogContent2 = _interopRequireDefault(require("@mui/material/DialogContent"));
var _Box2 = _interopRequireDefault(require("@mui/material/Box"));
var _Typography2 = _interopRequireDefault(require("@mui/material/Typography"));
var _DialogTitle2 = _interopRequireDefault(require("@mui/material/DialogTitle"));
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _styledComponents = require("styled-components");
var _button = require("./button");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function CancelChallengeEditionDialog({
  ...props
}) {
  return /*#__PURE__*/_react.default.createElement(_Dialog2.default, _extends({
    fullWidth: true,
    maxWidth: "sm",
    onClose: () => props.handleClose()
  }, props, {
    sx: {
      '.MuiPaper-root': {
        borderRadius: 4
      }
    }
  }), /*#__PURE__*/_react.default.createElement(_DialogTitle2.default, {
    color: "#283859",
    fontSize: "1.5rem",
    fontWeight: "700",
    marginBottom: 2
  }, /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    i18nKey: "commons.challenge_post.form.leave_update"
  })), /*#__PURE__*/_react.default.createElement(_DialogContent2.default, null, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    display: "flex",
    flexDirection: "column",
    gap: 3
  }, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    variant: "body2"
  }, /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    i18nKey: "commons.challenge_post.form.leave_without_saving"
  })))), /*#__PURE__*/_react.default.createElement(_DialogActions2.default, {
    sx: {
      padding: '0 24px 16px',
      gap: '8px'
    }
  }, /*#__PURE__*/_react.default.createElement(StyledButton, {
    color: "primary",
    onClick: () => props.handleClose(),
    size: "large",
    variant: "outlined"
  }, /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    i18nKey: "commons.actions.cancel"
  })), /*#__PURE__*/_react.default.createElement(StyledButton, {
    disableElevation: true,
    color: "primary",
    onClick: () => props.handleClose(true),
    size: "large",
    variant: "contained"
  }, /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    i18nKey: "commons.actions.confirm"
  }))));
}
const StyledButton = (0, _styledComponents.styled)(_button.Button)`
  && {
    border-radius: 8px;
  }
`;
var _default = exports.default = CancelChallengeEditionDialog;